export interface userState {
  id: string;
  name: string;
  company: string;
  isAuth: boolean;
  isPermission: boolean;
  isAdmin: boolean;
  isSuperAdmin: boolean;
  apiUrl: string;
  picture: string;
}

export interface IMenuItem {
  name: string;
  iconType: string;
  icon: any;
  path: string;
  linkType?: string;
  adminOnly?: boolean;
  children?: Array<IMenuItem>;
}

export interface CountryType {
  code: string;
  label: string;
  englabel: string;
  language?: string;
}

export const broadStatusName: any = {
  CREATE: "대기",
  READY: "대기",
  START: "방송",
  STOP: "종료",
  VOD: "VOD",
};

export const iotConfig: any = {
  region: "ap-northeast-2",
  identityPollId: "ap-northeast-2:c616107d-9671-4be9-b220-2e8fab303831",
  endpoint: "ws-dev.hd-smartstore.com",
};

export const appConfig = {
  listChannelMode: "recent" /*recent or total*/,
  quote_separator: "⤷",
  vod_cloudfront_endpoint: "https://vod-dev.hd-smartstore.com",
  asset_cloudfront_endpoint: "https://asset-dev.hd-smartstore.com",
  chat_id_mask: true,
};

export const emojiList = [
  "😀",
  "😁",
  "😂",
  "😃",
  "😉",
  "😋",
  "😎",
  "😍",
  "😗",
  "🤗",
  "🤔",
  "😣",
  "😫",
  "😴",
  "😌",
  "🤓",
  "😛",
  "😜",
  "😠",
  "😇",
  "😷",
  "😈",
  "👻",
  "😺",
  "😸",
  "😹",
  "😻",
  "😼",
  "😽",
  "🙀",
  "🙈",
  "🙉",
  "🙊",
  "👼",
  "👮",
  "🕵",
  "💂",
  "👳",
  "🎅",
  "👸",
  "👰",
  "👲",
  "🙍",
  "🙇",
  "🚶",
  "🏃",
  "💃",
  "⛷",
  "🏂",
  "🏌",
  "🏄",
  "🚣",
  "🏊",
  "⛹",
  "🏋",
  "🚴",
  "👫",
  "💪",
  "👈",
  "👉",
  "👉",
  "👆",
  "🖕",
  "👇",
  "🖖",
  "🤘",
  "🖐",
  "👌",
  "👍",
  "👎",
  "✊",
  "👊",
  "👏",
  "🙌",
  "🙏",
  "🐵",
  "🐶",
  "🐇",
  "🐥",
  "🐸",
  "🐌",
  "🐛",
  "🐜",
  "🐝",
  "🍉",
  "🍄",
  "🍔",
  "🍤",
  "🍨",
  "🍪",
  "🎂",
  "🍰",
  "🍾",
  "🍷",
  "🍸",
  "🍺",
  "🌍",
  "🚑",
  "⏰",
  "🌙",
  "🌝",
  "🌞",
  "⭐",
  "🌟",
  "🌠",
  "🌨",
  "🌩",
  "⛄",
  "🔥",
  "🎄",
  "🎈",
  "🎉",
  "🎊",
  "🎁",
  "🎗",
  "🏀",
  "🏈",
  "🎲",
  "🔇",
  "🔈",
  "📣",
  "🔔",
  "🎵",
  "🎷",
  "💰",
  "🖊",
  "📅",
  "✅",
  "❎",
  "💯",
  "🩷",
  "❤️",
  "🧡",
  "💛",
  "💚",
  "🩵",
  "💙",
  "💜",
  "🖤",
  "🩶",
  "🤍",
  "🤎",
];

export type GiftItem = {
  ofrSeq: string;
  ofrNm: string;
  offrQty: number;
  imgPath?: string;
};

export type DrawItem = {
  user_id: string;
  cust_no: string;
  apply_dtm: string;
};

export type DrawResult = {
  user_id: string;
  cust_no: string;
  apply_dtm: string;
  ofrNm: string;
};
